export const toHumanDate = (date: Date): string => (date ? date.toLocaleDateString('ru-RU') : '');

export const toHumanTextDate = (date: Date): string => date.toLocaleDateString('ru', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});
